import { useSelector } from 'react-redux';
import { ConsentStatus, selectConsentStatus } from 'app/helpers/consent';
const isConsentReady = () => {
  const consentStatus = useSelector(selectConsentStatus);
  return consentStatus === ConsentStatus.TCLOADED;
};
export { isConsentReady };